import React, { useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

// --- IMPORTACIÓN DE IMÁGENES (Conservando todas las referencias) ---
import image1 from "../assets/premioSlider1.webp"
import image2 from "../assets/premioSlider2.webp"
import image3 from "../assets/premioSlider3.webp"
import image4 from "../assets/premioSlider4.webp"
import image5 from "../assets/premioSlider5.webp"
import image6 from "../assets/premioSlider6.webp"
import image7 from "../assets/premioSlider7.webp"
import image8 from "../assets/premioSlider8.webp"
import image9 from "../assets/premioSlider9.webp"
import image10 from "../assets/premioSlider10.webp"
import image11 from "../assets/premioSlider11.webp"
import image12 from "../assets/premioSlider12.webp"
import image13 from "../assets/premioSlider13.webp"

import slider20261 from '../assets/slider20261.webp'
import slider20262 from '../assets/slider20262.webp'
import slider20263 from '../assets/slider20263.webp'
import slider20264 from '../assets/slider20264.webp'
import slider20265 from '../assets/slider20265.webp'
import slider20266 from '../assets/slider20266.webp'
import slider20267 from '../assets/slider20267.webp'
import slider20268 from '../assets/slider20268.webp'

import slider20251 from '../assets/slider20251.webp'
import slider20252 from '../assets/slider20252.webp'
import slider20253 from '../assets/slider20253.webp'
import slider20254 from '../assets/slider20254.webp'

import slider20241 from '../assets/slider20241.webp'
import slider20242 from '../assets/slider20242.webp'
import slider20243 from '../assets/slider20243.webp'
import slider20244 from '../assets/slider20244.webp'

import slider20231 from '../assets/slider20231.webp'
import slider20232 from '../assets/slider20232.webp'
import slider20233 from '../assets/slider20233.webp'
import slider20234 from '../assets/slider20234.webp'
import slider20235 from '../assets/slider20235.webp'
import slider20236 from '../assets/slider20236.webp'
import slider20237 from '../assets/slider20237.webp'
import slider20238 from '../assets/slider20238.webp'
import slider20239 from '../assets/slider20239.webp'
import slider202310 from '../assets/slider202310.webp'
import slider202311 from '../assets/slider202311.webp'
import slider202312 from '../assets/slider202312.webp'
import slider202313 from '../assets/slider202313.webp'
import slider202314 from '../assets/slider202314.webp'

import slider20221 from "../assets/slider20221.webp"
import slider20222 from "../assets/slider20222.webp"
import slider20223 from "../assets/slider20223.webp"

import slider20211 from "../assets/slider20211.webp"
import slider20212 from "../assets/slider20212.webp"
import slider20213 from "../assets/slider20213.webp"

import slider20191 from "../assets/slider20191.webp"
import slider20192 from "../assets/slider20192.webp"
import slider20193 from "../assets/slider20193.webp"
import slider20194 from "../assets/slider20194.webp"
import slider20195 from "../assets/slider20195.webp"
import slider20196 from "../assets/slider20196.webp"
import slider20197 from "../assets/slider20197.webp"

import slider20181 from "../assets/slider20181.webp"
import slider20182 from "../assets/slider20182.webp"
import slider20185 from "../assets/slider20185.webp"
import slider20186 from "../assets/slider20186.webp"
import slider20187 from "../assets/slider20187.webp"
import slider20188 from "../assets/slider20188.webp"
import slider20189 from "../assets/slider20189.webp"
import slider201810 from "../assets/slider201810.webp"
import slider201811 from "../assets/slider201811.webp"
import slider201812 from "../assets/slider201812.webp"
import slider201813 from "../assets/slider201813.webp"
import slider201814 from "../assets/slider201814.webp"
import slider201815 from "../assets/slider201815.webp"
import slider201816 from "../assets/slider201816.webp"
import slider201817 from "../assets/slider201817.webp"
import slider201818 from "../assets/slider201818.webp"
import slider201819 from "../assets/slider201819.webp"
import slider201820 from "../assets/slider201820.webp"

import Navbar from "./Navbar";
import Footer from "./Footer";
import ModalPremio from "./ModalPremio";
import ScrollToTop from './ScrollToTop';

// Componente de Tarjeta Reutilizable para mejor estética
const PremioCard = ({ title, text, images, onOpen, modalComponent, children, noImages }) => {
  return (
    <div className='w-full max-w-[1200px] mx-auto mb-20 px-4'>
      <div className='bg-white rounded-[2.5rem] shadow-xl overflow-hidden border border-slate-100 flex flex-col'>

        {/* Sección Superior: Imagen y Texto */}
        <div className={`flex flex-col ${noImages ? '' : 'lg:flex-row'}`}>

          {/* Lado Izquierdo: Carrusel (Si hay imágenes) */}
          {!noImages && images && images.length > 0 && (
            <div className='lg:w-1/2 bg-slate-100 relative'>
              <Carousel
                showStatus={false}
                showThumbs={false}
                infiniteLoop={true}
                autoPlay={true}
                interval={5000}
                className='h-full'
              >
                {images.map((img, index) => (
                  <div key={index} className='h-[350px] lg:h-[500px]'>
                    <img src={img} alt="Premio Slide" className='object-cover h-full w-full' />
                  </div>
                ))}
              </Carousel>
            </div>
          )}

          {/* Lado Derecho: Contenido */}
          <div className={`${noImages ? 'w-full' : 'lg:w-1/2'} p-8 lg:p-12 flex flex-col justify-center`}>
            <div className='w-12 h-1.5 bg-blue-600 mb-6 rounded-full'></div>
            <h2 className='text-3xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight'>
              {title}
            </h2>
            <p className='text-slate-600 text-lg leading-relaxed text-justify mb-8 font-light'>
              {text}
            </p>

            {onOpen && (
              <div className='mt-auto'>
                <button
                  onClick={onOpen}
                  className='bg-slate-900 hover:bg-blue-700 text-white px-10 py-3 rounded-2xl font-bold transition-all shadow-lg transform hover:-translate-y-1'
                >
                  Ver más
                </button>
                {/* Renderizamos el componente Modal pasado como prop */}
                {modalComponent}
              </div>
            )}
          </div>
        </div>

        {/* Sección Inferior: Listas de Docentes (si existen) */}
        {children && (
          <div className='bg-slate-50 border-t border-slate-200 p-8 lg:p-12'>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

const Premio = () => {
  const [showMyModal1, setShowMyModal1] = useState(false);
  const [showMyModal2, setShowMyModal2] = useState(false);
  const [showMyModal3, setShowMyModal3] = useState(false);
  const [showMyModal4, setShowMyModal4] = useState(false);
  const [showMyModal5, setShowMyModal5] = useState(false);
  const [showMyModal6, setShowMyModal6] = useState(false);
  const [showMyModal7, setShowMyModal7] = useState(false);
  const [showMyModal8, setShowMyModal8] = useState(false);
  const [showMyModal9, setShowMyModal9] = useState(false);
  const [showMyModal10, setShowMyModal10] = useState(false);

  return (
    <div className='bg-slate-50 min-h-screen'>
      <ScrollToTop />
      <Navbar />

      <div className='pt-32 pb-16'>

        {/* --- HERO SECTION --- */}
        <div className='max-w-[1000px] mx-auto px-4 mb-24'>
          <h1 className="text-4xl md:text-6xl text-center font-black mb-10 text-slate-900 tracking-tight leading-none uppercase">
            Premio a la Vida y Obra <br /><span className='text-blue-700'>del Pedagogo</span>
          </h1>
          <p className='text-center text-slate-500 font-bold tracking-widest uppercase text-sm mb-12'>Fundadocente JDD - AsoBiffi</p>

          <div className='rounded-[2.5rem] overflow-hidden shadow-2xl border-4 border-white'>
            <Carousel showThumbs={false} infiniteLoop autoPlay interval={4000} showStatus={false}>
              {[
                { img: image13, legend: "Ganadores 2017" },
                { img: image1, legend: "Ceremonia de Premiación 2019" },
                { img: image2, legend: "Ganadores del Premio 1era Edición" },
                { img: image3, legend: "Maria Eugenia Arias, Ganadora 2018" },
                { img: image4, legend: "Eduardo Pulido, Primer Puesto" },
                { img: image5, legend: "En compañia de las rectoras" },
                { img: image6, legend: "Jorge Moreno, Segundo Puesto" },
                { img: image7, legend: "Ceremonia de reconocimiento 2019" },
                { img: image8, legend: "Claudia Rodriguez, Tercer Puesto" },
                { img: image9, legend: "" },
                { img: image10, legend: "Ganadores 2017 con Ana Vergara" },
                { img: image11, legend: "Eduardo Pulido y directivos" },
                { img: image12, legend: "Ceremonia Oficial" }
              ].map((item, idx) => (
                <div key={idx} className='relative'>
                  <img src={item.img} alt={`Slide ${idx}`} />
                  {item.legend && <p className="legend font-bold text-lg !bg-black/60 !opacity-100">{item.legend}</p>}
                </div>
              ))}
            </Carousel>
          </div>

          <div className='mt-12 bg-white p-8 rounded-3xl shadow-lg border border-slate-100 text-center'>
            <p className='text-slate-600 text-lg leading-relaxed mb-4'>
              El Premio Vida y Obra del Pedagogo se crea con el objetivo de exaltar la labor de aquellos docentes que desde su área de desempeño, realizan actividades de significativo impacto en sus estudiantes, familias y entorno en el que se desenvuelve.
            </p>
            <p className=' text-lg leading-relaxed font-medium text-blue-800'>
              Mediante la entrega de este reconocimiento se busca promover una participación activa e integral de los docentes, favoreciendo así la construcción de una mejor sociedad.
            </p>
          </div>
        </div>

        {/* --- 2026 --- */}
        <PremioCard
          title="Entrega del 10mo. Premio Vida y Obra del Pedagogo año 2026"
          text="Fundación FUNDA DOCENTE JDD, Celebró la decima entrega del premio vida y obra del Pedagogo"
          images={[slider20261, slider20262, slider20263, slider20264, slider20265, slider20266, slider20267, slider20268,]}
          onOpen={() => setShowMyModal10(true)}
          modalComponent={<ModalPremio year={2026} onClose={() => setShowMyModal10(false)} visible={showMyModal10} />}
        >
          <div className='grid md:grid-cols-2 gap-10 text-slate-700'>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Resaltados</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>MONICA DEL CARMEN CERVANTES MUÑOZ</p>
                <p className='italic font-light'>El Arte como Camino para Transformar Vidas, através del arte
                  los estudiantes participantes podían crear una conversación interior y exponer sus sentimientos.
                  Es una herramienta que le permite como docente acercarse a las problemáticas de sus estudiantes
                  en su entorno educativo, familiar y social.</p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>YESID YAIR SOLANO RINCONES</p>
                <p className='italic font-light'>Innovación Motor para el Aprender Haciendo, Aprender haciendo
                  implica permitir que el estudiante se equivoque, que
                  el primer programa probablemente no funcionará, que el robot
                  puede tomar una ruta equivocada y que una idea puede necesitar
                  varias versiones antes de convertirse en una solución.
                </p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>ALFONSO JACOBO GARCIA ZUÑIGA</p>
                <p className='italic font-light'>Educar Desde el Agua. Mi misión nunca ha sido
                  únicamente enseñar una técnica, sino acompañarlo para que
                  descubra que es capaz de superar sus propios límites. La
                  natación me ha permitido educar el cuerpo, pero sobre todo
                  formar el carácter.
                </p>
              </div>
            </div>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Promotores Resaltados</h3>
              <div className='mb-6'>
                <p className='italic font-light'>Reconocimiento  por ser  promotores de una causa que transforma vidas, con esperanza, compormiso con el servicio y bien común.</p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>ANA LAUDITH VERGARA VEGA </p>
                <p className='italic font-light'>Rectora del Colegio Biffi La Salle.</p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>CARLOS OSPINA - GUSTAVO QUINTERO - OSCAR FERNÁNDEZ (Q.E.P.D) </p>
                <p className='italic font-light'>Fundación de exalumnos del Colegio Biffi La Salle ASOBIFFI</p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>HMNO RAMÓN GÓMEZ - HMNO RAMÓN BOTERO </p>
                <p className='italic font-light'>Congregación de los Hermanos de las Escuelas Cristianas "LA SALLE"</p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>FUNDACIÓN JAVIER DUQUE DUQUE</p>
                <p className='italic font-light'>Fundación de exalumnos del Colegio Biffi La Salle otorga reconocimiento a Fundación Vida y Obra del docente Javier Duque Duque por sus 10 años de exaltación del trabajo de los profesores, obras sociales y ayudas a la comunidad vulnerable de la región.</p>
              </div>
            </div>
          </div>
        </PremioCard>

        {/* --- 2025 --- */}
        <PremioCard
          title="Entrega del 9no. Premio Vida y Obra del Pedagogo año 2025"
          text="Fundación FUNDA DOCENTE JDD, Celebró la novena entrega del premio vida y obra del Pedagogo"
          images={[slider20251, slider20252, slider20253, slider20254]}
          onOpen={() => setShowMyModal9(true)}
          modalComponent={<ModalPremio year={2025} onClose={() => setShowMyModal9(false)} visible={showMyModal9} />}
        >
          <div className='grid md:grid-cols-2 gap-10 text-slate-700'>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Eméritos</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>ROBERTO GARCÍA PEÑA</p>
                <p className='italic font-light'>Docente con trabajo destacado en las áreas de humanista Acompañamiento académico y orientación psicosexual a jóvenes. Líder orientador en estidades educativas públicas y privadas</p>
              </div>
            </div>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Resaltados</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>JOSE LUIS PERTUZ CABEZA</p>
                <p className='italic font-light'>Líder orientador en la líneas contables y empresariales formando jóvenes emprendedores.</p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>ANTONIO A GARCÍA GARCÍA</p>
                <p className='italic font-light'>Educador con liderazgo en las ciencias naturales biología química con el objetivo de formar jóvenes comprometidos con el cuidado del medio ambiente. Ha publicado más de 5 libros.</p>
              </div>
            </div>
          </div>
        </PremioCard>

        {/* --- 2024 --- */}
        <PremioCard
          title="Entrega del 8vo. Premio Vida y Obra del Pedagogo año 2024"
          text="Fundación FUNDA DOCENTE JDD, Celebró la octava entrega del premio vida y obra del Pedagogo"
          images={[slider20241, slider20242, slider20243, slider20244]}
          onOpen={() => setShowMyModal8(true)}
          modalComponent={<ModalPremio year={2024} onClose={() => setShowMyModal8(false)} visible={showMyModal8} />}
        >
          <div className='grid md:grid-cols-2 gap-10 text-slate-700'>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Eméritos</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>RDO. HNO. EDUARDO BOTERO GALLEGO</p>
                <p className='italic font-light'>Su vida como educador y formador la ha desarrollado en la comunidad de hermanos cristianos de La Salle donde es valorado por sus valores humanistas y de inclusión.</p>
              </div>
              <div>
                <p className='font-bold text-lg text-slate-900'>EDGARDO TOBIAS CLAVIJO MUÑOZ</p>
                <p className='italic font-light'>Su labor como docente se resalta por sus aportes educativos en el colegio Bifi, instituto La Salle y escuelas publicas de Caracoli.</p>
              </div>
            </div>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Resaltados</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>HECTOR A. IRIARTE MARTINEZ</p>
                <p className='italic font-light'>Construye su proyecto musical para el benéfico de la comunidad del barrio Nelson Mandela en Cartagena.</p>
              </div>
              <div>
                <p className='font-bold text-lg text-slate-900'>INT. RODOLFO A. CONEO MARTINEZ</p>
                <p className='italic font-light'>Ha sido resaltado en diferentes ocasiones como un excelente Docente Policial por la comunidad Académica.</p>
              </div>
            </div>
          </div>
        </PremioCard>

        {/* --- 2023 --- */}
        <PremioCard
          title="Entrega del 7mo. Premio Vida y Obra del Pedagogo año 2023"
          text="Fundación FUNDA DOCENTE JDD, Celebró la septima entrega del premio vida y obra del Pedagogo"
          images={[slider20231, slider20232, slider20233, slider20234, slider20235, slider20236, slider20237, slider20238, slider20239, slider202310, slider202311, slider202312, slider202313, slider202314]}
          onOpen={() => setShowMyModal7(true)}
          modalComponent={<ModalPremio year={2023} onClose={() => setShowMyModal7(false)} visible={showMyModal7} />}
        >
          <div className='grid md:grid-cols-2 gap-10 text-slate-700'>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Eméritos</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>NESTOR ALBOR SARMIENTO</p>
                <p className='italic font-light'>Bilingüismo herramienta básicas en el desarrollo académico de la juventud</p>
              </div>
              <div>
                <p className='font-bold text-lg text-slate-900'>ROBINSON PEÑA VALENCIA</p>
                <p className='italic font-light'>Las herramientas en la comunicación eje de interacción social y académico</p>
              </div>
            </div>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Resaltados</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>NUBIA HUERTAS CAMACHO</p>
                <p className='italic font-light'>Una escuela contruida en comunidad y para la comunidad</p>
              </div>
              <div>
                <p className='font-bold text-lg text-slate-900'>MARGARITA SABALZA MAESTRE</p>
                <p className='italic font-light'>Artes plasticas e innovacion tecnologica, promotor para las mejoras en comunidades rurales</p>
              </div>
            </div>
          </div>
        </PremioCard>

        {/* --- 2022 --- */}
        <PremioCard
          title="Entrega del 6to. Premio Vida y Obra del Pedagogo año 2022"
          text="Fundación FUNDA DOCENTE JDD, Celebró la sexta entrega del premio vida y obra del Pedagogo"
          images={[slider20221, slider20222, slider20223]}
          onOpen={() => setShowMyModal1(true)}
          modalComponent={<ModalPremio year={2022} onClose={() => setShowMyModal1(false)} visible={showMyModal1} />}
        >
          <div className='grid md:grid-cols-2 gap-10 text-slate-700'>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Eméritos</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>JOSÉ MANUEL PEREZ SARMIENTO</p>
                <p className='italic font-light'>Las Ciencias Naturales y la Biología caminos para el conocimiento</p>
              </div>
              <div>
                <p className='font-bold text-lg text-slate-900'>MANUEL VARELA BARRAZA</p>
                <p className='italic font-light'>La educación es el medio para cambiar entornos para el bienestar de las comunidades</p>
              </div>
            </div>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Resaltados</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>DIANA FISCHER PEÑA</p>
                <p className='italic font-light'>Escuela El Corral de San Luis Tubara. La educación en comunidades vulnerables</p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>REYMES ROBERTO ROCHA GOMEZ</p>
                <p className='italic font-light'>Instituto La Salle Barranquilla. La musica inspira a comunidades discapacitadas</p>
              </div>
              <div>
                <p className='font-bold text-lg text-slate-900'>EDGAR ASICLO HEREDIA REYES</p>
                <p className='italic font-light'>IED Santuario Barranquilla. Convivencias afirmativas y la educación grupal</p>
              </div>
            </div>
          </div>
        </PremioCard>

        {/* --- 2021-2020 --- */}
        <PremioCard
          title="Entrega del 5to. Premio Vida y Obra del Pedagogo año 2021 - 2020"
          text="La 5ª. Versión del Premio Vida y Obra del Pedagogo, incluyó profesores nominados en el año 2020, que no fueron premiados en ese año por la pandemia COVID 19 que nos obligó a cancelar esta actividad. El día 27 de octubre de 2021 se llevó a cabo en el Club ABC de Barranquilla la entrega de reconocimientos."
          images={[slider20211, slider20212, slider20213]}
          onOpen={() => setShowMyModal2(true)}
          modalComponent={<ModalPremio year={2021} onClose={() => setShowMyModal2(false)} visible={showMyModal2} />}
        >
          <div className='grid md:grid-cols-2 gap-10 text-slate-700'>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Eméritos</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>JESUS MARIA ACEVEDO PALMA</p>
                <p className='italic font-light'>El deporte, base para el bienestar del ser humano.</p>
              </div>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>JUSTO VARGAS LASCARRO</p>
                <p className='italic font-light'>Las humanidades y el servicio social, hilo conductor para unir las comunidades.</p>
              </div>
              <div>
                <p className='font-bold text-lg text-slate-900'>ADONAY JARAMILLO GARRIDO</p>
                <p className='italic font-light'>Las matemáticas y su método de enseñanza, forman estudiantes de alto desempeño.</p>
              </div>
            </div>
            <div>
              <h3 className='font-black text-blue-700 mb-4 tracking-widest text-sm uppercase'>Docentes Resaltados</h3>
              <div className='mb-6'>
                <p className='font-bold text-lg text-slate-900'>ALVARO BUSTILLO SOLANO</p>
                <p className='italic font-light'>IED Marco Fidel Suarez. Carnaval, cultura, arte y educación.</p>
              </div>
              <div>
                <p className='font-bold text-lg text-slate-900'>SERGIO NIÑO ARAQUE</p>
                <p className='italic font-light'>COLEGIO BIFFI LA SALLE. Proyectos académicos una herramienta educativa.</p>
              </div>
            </div>
          </div>
        </PremioCard>

        {/* --- 2020 (Texto solo) --- */}
        <div className='w-full max-w-[1200px] mx-auto mb-20 px-4'>
          <div className='bg-slate-100 rounded-[2.5rem] p-12 shadow-inner'>
            <div className='grid md:grid-cols-2 gap-10 items-center'>
              <div>
                <h2 className='text-3xl font-black text-slate-800 mb-4'>Premio Vida y Obra del Pedagogo Año 2020</h2>
                <p className='text-slate-600 text-lg text-justify'>
                  Por motivo del aislamiento decretado por el Gobierno nacional, no se pudo realizar la ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su quinta edición.
                </p>
              </div>
              <div className='bg-white p-8 rounded-2xl shadow-sm'>
                <h3 className='font-black text-blue-700 mb-6 tracking-widest text-sm uppercase'>Docentes Nominados</h3>
                <ul className='space-y-3 font-bold text-slate-700'>
                  <li>• ESPERANZA MENDOZA BLANCO</li>
                  <li>• JULIO ADÁN HERNÁNDEZ</li>
                  <li>• ÁLVARO BUSTILLO</li>
                  <li>• GEOVANNY QUINTERO</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* --- 2019 --- */}
        <PremioCard
          title="Premio Vida y Obra del Pedagogo Año 2019"
          text="La ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su cuarta edición, se realizó el 24 de Octubre en el club ABC en ciudad de Barranquilla, Colombia. Durante la misma se hizo entrega de placas al docente Fausto Chatella y a la docente Carmen Curcio. Así mismo se exalto a la Congregación de los Hermanos de la Escuelas Cristianas de La Salle y al Instituto Hijas de Maria Auxiliadora."
          images={[slider20191, slider20192, slider20193, slider20194, slider20195, slider20196, slider20197]}
          onOpen={() => setShowMyModal3(true)}
          modalComponent={<ModalPremio year={2019} onClose={() => setShowMyModal3(false)} visible={showMyModal3} />}
        />

        {/* --- 2018 --- */}
        <PremioCard
          title="Premio Vida y Obra del Pedagogo Año 2018"
          text="La ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su tercera edición, se realizó el 30 de Octubre en el club ABC en ciudad de Barranquilla, Colombia. Durante la misma se hizo entrega de placas al docente Luis Hoyos vinculado al Colegio La Salle Montería y ganador del premio en primer lugar, y a la docente Maria Eugenia Arias del Instituto La Salle Barranquilla ganadora en segundo lugar."
          images={[slider20181, slider20182, slider20185, slider20186, slider20187, slider20188, slider20189, slider201810, slider201811, slider201812, slider201813, slider201814, slider201815, slider201816, slider201817, slider201818, slider201819, slider201820]}
          onOpen={() => setShowMyModal4(true)}
          modalComponent={<ModalPremio year={2018} onClose={() => setShowMyModal4(false)} visible={showMyModal4} />}
        />

        {/* --- 2017 --- */}
        <PremioCard
          noImages={true}
          title="Premio Vida y Obra del Pedagogo Año 2017"
          text="La ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su segunda edición, se realizó el 05 de Diciembre en el club ABC en ciudad de Barranquilla, Colombia. Durante la misma se hizo entrega de placas a los docentes Andreana Heredia y Naileth Caballero ganadores del premio en primer lugar, y al docente Manuel Rios ganador en segundo lugar."
          onOpen={() => setShowMyModal5(true)}
          modalComponent={<ModalPremio year={2017} onClose={() => setShowMyModal5(false)} visible={showMyModal5} />}
        />

        {/* --- 2016 --- */}
        <PremioCard
          noImages={true}
          title="Premio Vida y Obra del Pedagogo Año 2016"
          text="La ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su primera edición, se realizó el 18 de Noviembre en las instalaciones del Colegio Biffi La Salle en la ciudad de Barranquilla, Colombia. Durante la misma se hizo entrega de placas a los docentes Eduardo Pulido y Jorge Moreno, ganadores del premio en primer y segundo lugar respectivamente. A su vez, se hizo entrega de una mención de honor a la psicóloga Claudia Rodríguez por su participación."
          onOpen={() => setShowMyModal6(true)}
          modalComponent={<ModalPremio year={2016} onClose={() => setShowMyModal6(false)} visible={showMyModal6} />}
        />

      </div>
      <Footer />
    </div>
  );
};

export default Premio;